export default __webpack_public_path__ + "static/media/iconClean.b8f0d278.svg";